import {
  useSortable,
  SortableContext,
  horizontalListSortingStrategy
} from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

import { AtThePlaceWord } from './Word'

interface BoardProps {
  id: string
  items: string[]
  disabled?: boolean
}

export function AtThePlaceBoard({ id, items, disabled = false }: BoardProps) {
  const { active, over, setNodeRef } = useSortable({
    id,
    data: {
      type: 'container',
      children: items
    },
    disabled
  })

  const isOverContainer = over
    ? (id === over.id && active?.data.current?.type !== 'container') ||
      items.includes(over.id as string)
    : false

  return (
    <SortableContext
      id={id}
      items={items}
      strategy={horizontalListSortingStrategy}
      disabled={disabled}
    >
      <div
        id={id}
        ref={setNodeRef}
        className={`
          w-full min-h-[150px] flex flex-row flex-wrap items-start content-start gap-3
          p-3 lg:p-4 rounded-b-xl transition-colors
          ${isOverContainer ? 'bg-gray-300' : 'bg-gray-200'}
        `}
      >
        {items.map((wordId: string) => (
          <AtThePlaceWord
            key={wordId}
            id={wordId}
            text={wordId}
            disabled={disabled}
          />
        ))}
        {id && items && items.length === 0 && (
          <span className="text-gray-600 dark:text-white text-lg font-medium block w-full text-center my-auto">
            Arraste as expressões corretas para cá
          </span>
        )}
      </div>
    </SortableContext>
  )
}
